import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxColumnFixing = _resolveComponent("DxColumnFixing")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxFormGrid = _resolveComponent("DxFormGrid")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxLookup = _resolveComponent("DxLookup")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxSimpleItem = _resolveComponent("DxSimpleItem")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!

  return (_openBlock(), _createElementBlock("div", {
    class: "emp-card",
    key: `emp-${_ctx.employeeId}`
  }, [
    _createVNode(_component_DxDataGrid, {
      "data-source": _ctx.dsCentre,
      ref: "dataGridRef",
      "allow-column-reordering": true,
      "allow-column-resizing": true,
      "column-auto-width": false,
      "show-borders": true,
      "key-expr": "Id",
      onRowDblClick: _ctx.onRowDblClick
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DxSelection, { mode: "single" }),
        _createVNode(_component_DxFilterRow, { visible: false }),
        _createVNode(_component_DxPaging, {
          "page-size": 10,
          "page-index": 0
        }),
        _createVNode(_component_DxLoadPanel, {
          enabled: true,
          "indicator-src": 'reload6.gif'
        }),
        _createVNode(_component_DxSorting, { mode: "multiple" }),
        _createVNode(_component_DxScrolling, {
          mode: "standard",
          "show-scrollbar": 'always'
        }),
        _createVNode(_component_DxColumnFixing, { enabled: true }),
        _createVNode(_component_DxEditing, {
          "allow-updating": true,
          "allow-deleting": true,
          mode: "popup"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxPopup, {
              closeOnOutsideClick: false,
              showCloseButton: false,
              width: 700,
              height: 380,
              "show-title": false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxToolbarItem, { template: _ctx.customTitleTemplate }, null, 8, ["template"]),
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "after",
                  options: _ctx.saveButtonOptions
                }, null, 8, ["options"]),
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "after",
                  options: _ctx.dangerButtonOptions
                }, null, 8, ["options"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxFormGrid, { "col-count": 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_DxItem, {
                  "data-field": "CapitolId",
                  label: { text: 'Centru de cost' },
                  "col-span": 2
                }),
                _createVNode(_component_DxItem, {
                  "data-field": "ProcentDinTotal",
                  label: { text: '% Alocat' },
                  "editor-type": "dxNumberBox"
                }),
                _createVNode(_component_DxItem, {
                  "data-field": "ContId",
                  label: { text: 'Cont contabil' },
                  "col-span": 2
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CapitolId",
          caption: "Centru de cost",
          width: "300"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxLookup, {
              "data-source": _ctx.dsCapitoleLookup,
              "value-expr": "Id",
              "display-expr": _ctx.capitolDisplay,
              "search-enabled": true
            }, null, 8, ["data-source", "display-expr"])
          ]),
          _: 1
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ProcentDinTotal",
          caption: "% Alocat",
          width: "120"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ContId",
          caption: "Cont contabil",
          width: "300"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxLookup, {
              "data-source": _ctx.dsConturiLookup,
              "value-expr": "Id",
              "display-expr": _ctx.contDisplay,
              "search-enabled": true
            }, null, 8, ["data-source", "display-expr"])
          ]),
          _: 1
        }),
        _createVNode(_component_DxToolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_DxItem, null, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "add",
                  type: "success",
                  onClick: _ctx.onAddClick
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data-source", "onRowDblClick"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.addPopupVisible,
      "show-title": true,
      height: 380,
      width: 700
    }, {
      title: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }, " Adăugare Centru de cost ", -1)
      ]))]),
      default: _withCtx(() => [
        _createVNode(_component_DxForm, {
          "col-count": 2,
          "form-data": _ctx.formData,
          "label-alignment": "left"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxSimpleItem, {
              "data-field": "CapitolId",
              label: { text: 'Centru de cost' },
              "col-span": 2,
              "editor-type": "dxSelectBox",
              "editor-options": {
                        dataSource: _ctx.dsCapitoleLookup,
                        valueExpr: 'Id',
                        displayExpr: _ctx.capitolDisplay,
                        searchEnabled: true,
                        showClearButton: true,
                        placeholder: 'Selectează'
                    }
            }, null, 8, ["editor-options"]),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "ProcentDinTotal",
              label: { text: '% Alocat' },
              "editor-type": "dxNumberBox"
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "ContId",
              label: { text: 'Cont contabil' },
              "col-span": 2,
              "editor-type": "dxSelectBox",
              "editor-options": {
                        dataSource: _ctx.dsConturiLookup,
                        valueExpr: 'Id',
                        displayExpr: _ctx.contDisplay,
                        searchEnabled: true,
                        showClearButton: true,
                        placeholder: 'Selectează'
                    }
            }, null, 8, ["editor-options"])
          ]),
          _: 1
        }, 8, ["form-data"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: _ctx.addButtonOptions
        }, null, 8, ["options"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: _ctx.closeButtonOptions
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}